import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useAuth } from "../composition-api/useAuth"

const useEnums = () => {
  const { fetchAuthAsync } = useAuth()

  const transferStatuses = ref(new Map())
  const statuses = ref(new Map())
  const types = ref(new Map())
  const internalOrderTypes = ref(new Map())
  const deviceTypes = ref(new Map())
  const translations = ref(new Map())
  const roles = ref(new Map())
  const attachmentTypes = ref(new Map())
  const offerStatuses = ref(new Map())

  const loadEnumsAsync = async () => {
    const raw = await fetchAuthAsync(`${AZURE_URI}/Enums`, "GET")
    if (!raw?.statuses && !raw?.types) {
      throw new Error(`Failed to load enums: ${JSON.stringify(raw)}`)
    }
    transferStatuses.value = new Map(raw.transferStatuses.map(({ value, text }) => [value, text]))
    internalOrderTypes.value = new Map(raw.internalOrderTypes.map(({ value, text }) => [value, text]))
    statuses.value = new Map(raw.statuses.map(({ value, text }) => [value, text]))
    types.value = new Map(raw.types.map(({ value, text }) => [value, text]))
    deviceTypes.value = new Map(raw.deviceTypes.map(({ value, text }) => [value, text]))
    translations.value = new Map(raw.translations.map(({ value, text }) => [value, text]))
    roles.value = new Map(raw.roles.map(({ value, text }) => [value, text]))
    attachmentTypes.value = new Map(raw.attachmentTypes?.map(({ value, text }) => [value, text]) || [])
    offerStatuses.value = new Map(raw.offerStatuses?.map(({ value, text }) => [value, text]) || [])
  }

  return {
    deviceTypes,
    internalOrderTypes,
    statuses,
    types,
    transferStatuses,
    translations,
    offerStatuses,
    roles,
    attachmentTypes,
    loadEnumsAsync,
  }
}

export { useEnums }
